










import { Component, Vue, Prop } from 'vue-property-decorator'
import { linkJump } from '@bilibili/utils-leona'
import { SPM_ID } from '../utils/constants'
import logger from '@plat-components/utils2/_esm5/logger'

@Component({
  name: 'ListItem',
})
export default class ListItem extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {
      return {}
    },
  })
  item!: any

  get subTitle() {
    if (this.item) {
      const { indexShow, newEp } = this.item
      let res = indexShow || newEp?.indexShow
      return res
    } else {
      return ''
    }
  }

  navToWatch() {
    const { link, seasonId } = this.item
    logger('searchlist.click', {
      ssid: seasonId,
      from_spmid: SPM_ID,
    })
    linkJump({
      link: link,
    })
  }
}
